import { useEffect } from "react";

const useClickOutside = (containerRef, onClickOutside) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        if (onClickOutside) {
          onClickOutside();
        }
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, [containerRef]);
};

export default useClickOutside;
